import 'zone.js';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import ptBr from '@angular/common/locales/pt';
import ptBrExtra from '@angular/common/locales/extra/pt';
import enUs from '@angular/common/locales/en';
import enUsExtra from '@angular/common/locales/extra/en';
import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import { environment } from './environments/environment';

// Registrar locales
registerLocaleData(ptBr, 'pt-BR', ptBrExtra);
registerLocaleData(enUs, 'en-US', enUsExtra);

if (environment.datadog.enabled) {
  datadogRum.init({
    applicationId: environment.datadog.applicationId,
    clientToken: environment.datadog.clientToken,
    site: environment.datadog.site,
    service: 'gmcore-frontend',
    env: environment.datadog.env,
    sessionSampleRate: environment.datadog.sessionSampleRate,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
  });

  datadogLogs.init({
    clientToken: environment.datadog.clientToken,
    site: environment.datadog.site,
    service: 'gmcore-frontend',
    env: environment.datadog.env,
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ['error'],
    sessionSampleRate: environment.datadog.sessionSampleRate,
  });
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
